/* eslint-disable jsdoc/check-tag-names */

/**
 * @TODO: This whole styling-system is kinda scuffed and should be reworked if possible.
 * Especially the newly added state for "current" doesn't really work. Also, an item
 * can be active / back / current at the same time.
 *
 * Important: Remove the eslint-disable at the top of this file, as soo as this todo is done.
 */

export default {
	0: {
		default: `
            w-full group flex text-left items-center
            font-medium no-underline
            hover:underline hover:decoration-[1px] md:hover:decoration-[2px]
            underline-offset-[6px] xl:underline-offset-[8px]

			text-[1.25rem] leading-[1.75rem]
			[&>span]:py-[8px] md:[&>span]:py-[1px]
			md:text-[1.5rem] md:leading-[2.5rem]
		`,
		undecided: `
            w-full group flex text-left items-center
            font-medium no-underline
            hover:underline hover:decoration-[1px] md:hover:decoration-[2px]
            underline-offset-[6px] xl:underline-offset-[8px]

			text-[1.25rem] leading-[1.75rem]
			[&>span]:py-[8px] md:[&>span]:py-[1px]
			md:text-[1.5rem] md:leading-[2.5rem]
		`,
		active: `
            w-full group flex text-left items-center
            font-medium
            underline decoration-[2px] md:decoration-[4px] md:hover:decoration-[2px]
            underline-offset-[6px] xl:underline-offset-[8px]

			text-[1.25rem] leading-[1.75rem]
			[&>span]:py-[8px] md:[&>span]:py-[1px]
			md:text-[1.5rem] md:leading-[2.5rem]
		`,
		current: `
            w-full group flex text-left items-center
            font-medium
            underline decoration-[2px] md:decoration-[4px] md:hover:decoration-[2px]
            underline-offset-[6px] xl:underline-offset-[8px]

            bg-identity-yellow-80

			text-[1.25rem] leading-[1.75rem]
			[&>span]:py-[8px] md:[&>span]:py-[1px]
			md:text-[1.5rem] md:leading-[2.5rem]
        `,
	},
	1: {
		default: `
            w-full group flex text-left items-center
            font-medium no-underline
            hover:underline hover:decoration-[1px] md:hover:decoration-[2px]
            underline-offset-[6px] xl:underline-offset-[8px]

            text-[1.125rem] leading-[1.5625rem]
            [&>span]:py-[10px] md:[&>span]:py-[6px]
            xl:text-[1.375rem] xl:leading-[1.5]
        `,
		undecided: `
            w-full group flex text-left items-center
            font-medium no-underline
            hover:underline hover:decoration-[1px] md:hover:decoration-[2px]
            underline-offset-[6px] xl:underline-offset-[8px]

            text-[1.125rem] leading-[1.5625rem]
            [&>span]:py-[10px] md:[&>span]:py-[6px]
            xl:text-[1.375rem] xl:leading-[1.5]
		`,
		active: `
            w-full group flex text-left items-center
            font-medium
            underline decoration-[2px] md:decoration-[4px] md:hover:decoration-[2px]
            underline-offset-[6px] xl:underline-offset-[8px]

            text-[1.125rem] leading-[1.5625rem]
            [&>span]:py-[10px] md:[&>span]:py-[6px]
            xl:text-[1.375rem] xl:leading-[1.5]
		`,
		overview: `
            w-full group flex text-left items-center
            font-medium no-underline
            hover:underline hover:decoration-[1px] md:hover:decoration-[2px]
            underline-offset-[6px] xl:underline-offset-[8px]

            text-[1.125rem] leading-[1.5625rem]
            [&>span]:py-[10px] md:[&>span]:py-[6px]
            xl:text-[1.375rem] xl:leading-[1.5]
		`,
		back: `
            w-full group flex text-left items-center
            font-medium
            underline decoration-[2px] md:decoration-[4px] md:hover:decoration-[2px]
            underline-offset-[6px] xl:underline-offset-[8px]

            text-[1.25rem] leading-[1.75rem]
            [&>span]:py-[10px] md:[&>span]:py-[6px]
            xl:text-[2.3125rem] xl:leading-[1.5]
        `,
		current: `
            w-full group flex text-left items-center
            font-medium
            underline decoration-[2px] md:decoration-[4px] md:hover:decoration-[2px]
            underline-offset-[6px] xl:underline-offset-[8px]

            bg-identity-yellow-80

            text-[1.125rem] leading-[1.5625rem]
            [&>span]:py-[10px] md:[&>span]:py-[6px]
            xl:text-[1.375rem] xl:leading-[1.5]
        `,
	},
	"default": {
		default: `
            w-full group flex text-left items-center
            font-medium no-underline
            hover:underline hover:decoration-[1px] md:hover:decoration-[2px]
            underline-offset-[6px] xl:underline-offset-[8px]

            text-[1.125rem] leading-[1.5625rem]
            [&>span]:py-[10px] md:[&>span]:py-[6px]
            xl:text-[1.375rem] xl:leading-[1.5]
        `,
		undecided: `
            w-full group flex text-left items-center
            font-medium no-underline
            hover:underline hover:decoration-[1px] md:hover:decoration-[2px]
            underline-offset-[6px] xl:underline-offset-[8px]

            text-[1.125rem] leading-[1.5625rem]
            [&>span]:py-[10px] md:[&>span]:py-[6px]
            xl:text-[1.375rem] xl:leading-[1.5]
		`,
		active: `
            w-full group flex text-left items-center
            font-medium
            underline decoration-[2px] md:decoration-[4px] md:hover:decoration-[2px]
            underline-offset-[6px] xl:underline-offset-[8px]

            text-[1.125rem] leading-[1.5625rem]
            [&>span]:py-[10px] md:[&>span]:py-[6px]
            xl:text-[1.375rem] xl:leading-[1.5]
		`,
		overview: `
            w-full group flex text-left items-center
            font-medium no-underline
            hover:underline hover:decoration-[1px] md:hover:decoration-[2px]
            underline-offset-[6px] xl:underline-offset-[8px]

            text-[1.125rem] leading-[1.5625rem]
            [&>span]:py-[10px] md:[&>span]:py-[6px]
            xl:text-[1.375rem] xl:leading-[1.5]
		`,
		back: `
            w-full group flex text-left items-center
            font-medium
            underline decoration-[2px] md:decoration-[4px] md:hover:decoration-[2px]
            underline-offset-[6px] xl:underline-offset-[8px]

            text-[1.125rem] leading-[1.5625rem]
            [&>span]:py-[10px] md:[&>span]:py-[6px]
            xl:text-[1.375rem] xl:leading-[1.5]
		`,
		current: `
            w-full group flex text-left items-center
            font-medium
            underline decoration-[2px] md:decoration-[4px] md:hover:decoration-[2px]
            underline-offset-[6px] xl:underline-offset-[8px]

            bg-identity-yellow-80

            text-[1.125rem] leading-[1.5625rem]
            [&>span]:py-[10px] md:[&>span]:py-[6px]
            xl:text-[1.375rem] xl:leading-[1.5]
        `,
	},
};
